import React from "react";
import { ArrowBigRight, Castle, MapPin } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const ListingCard = ({ list }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        navigate(`/realty/listings/${list.listing_id}`);
      }}
      className="relative p-4 transform transition-all duration-300 border border-slate-800 rounded-3xl hover:border hover:border-gold cursor-pointer hover:shadow-gold"
    >
      <div className="aspect-[4/3 aspect-video w-full overflow-hidden rounded-xl">
        <img
          className="object-cover w-full h-full hover:scale-110 transition-transform duration-400"
          src={list.images?.[0]?.url}
          alt={list.title}
        />
      </div>

      {/* Badge */}
      <div className="absolute top-6 left-6 capitalize bg-gold text-black px-3 py-1 rounded-md font-semibold text-sm flex items-center gap-1">
        <Castle size={15} className="text-black" /> {list.type}
      </div>

      {/* Title */}
      <p className="my-6 text-xl font-semibold line-clamp-2 capitalize">
        {list.name}
      </p>

      {/* Footer */}
      <div className="flex items-center justify-between text-sm font-bold tracking-widest text-gray-500 uppercase">
        <div className="flex items-start text-gray-400 mb-4">
          <MapPin size={16} className="mr-1 text-gold shrink-0" />
          <span className="text-xs leading-tight">
            {list.location.address}, {list.location.city}, {list.location.state}
          </span>
        </div>
      </div>

      <Link
        to={`/realty/listings/${list.listing_id}`}
        className="flex items-center gap-2 text-gold text-end hover:underline transition"
      >
        Read more <ArrowBigRight size={15} />
      </Link>
    </div>
  );
};

export default React.memo(ListingCard);
